export default "__VITE_ASSET__DXOlrqiR__";